import { API } from "@aws-amplify/api";

export const saveAck = `mutation($input: saveAckInput) {
saveAck(input: $input) {
customerId
}
}`;



export async function saveAckToDB(inputData: any): Promise<any> {
  try {
    //return responseObject;
    return await API.graphql({ query: saveAck, variables: { input: inputData } });
  } catch (error) {
    console.log("saveAckToDB", error);
  }
}